
    import './styles.scoped.css';
    export default {
  "close-button": "awsui_close-button_16w0h_z9mit_93"
};
  